import {Pipe, PipeTransform} from '@angular/core';
import {SubMenuModel} from "../../pages/header/header.component";
import {PortalUser} from "@app/model/portal-user.model";

@Pipe({
    name: 'navFilter',
})
export class NavFilterPipe implements PipeTransform {
    transform(value: SubMenuModel[],  User: PortalUser): any {
        if(User.superAdmin){
            return value;
        }
        if(User.admin) {
            return value.filter(button => (button.role === 'admin'||button.role === 'limited' ||button.role === 'general') )
        }
        if(User.general) {
            return  value.filter(button => (button.role === 'limited' || button.role === 'general') )
        }
        if(User.limited) {
            return value.filter(button => (button.role === 'limited') )
        }
    }


}
